export const agenda = [
  {
      'id': 1,
      'title': 'Asesorías a personas físicas y morales sobre recursos administrativos.',
      'place': 'Pachuca de Soto',
      'start': '2024-08-15',
      'color': 'var(--wine)',
      'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> El día de hoy proporcionamos asesorías a personas físicas y morales sobre recursos administrativos y métodos alternativos de resolución de controversias, derivados de procedimientos de contratación. <a href="https://twitter.com/Contraloria_Hgo/status/1824211557741375515?ref_src=twsrc%5Etfw">Agosto 15 , 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
      'id': 2,
      'title': 'Álvaro Bardales junto a su equipo de trabajo se reunió vía remota.',
      'place': 'Pachuca de Soto',
      'start': '2024-09-18',
      'color': 'var(--wine)',
      'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> Nuestro titular Álvaro Bardales junto a su equipo de trabajo se reunió vía remota con las administraciones municipales para abordar temas sobre: "Nuevos Contralores Municipales y Obra Pública". #ElHidalgoQueQueremos. <a href="https://twitter.com/Contraloria_Hgo/status/1836473531116458411?ref_src=twsrc%5Etfw">Septiembre 18, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  }
  ,
  {
      'id': 3,
      'title': 'Región Centro Occidente de #ContraloresMx',
      'place': 'Colima, Colima',
      'start': '2024-09-20',
      'color': 'var(--wine)',
       'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> 2da Asamblea Ordinaria de la Región Centro Occidente de #ContraloresMx. #ElHidalgoQueQueremos. <a href="https://twitter.com/Contraloria_Hgo/status/1838251418832327150?ref_src=twsrc%5Etfw">Septiembre 20, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
      'id': 4,
      'title': 'Ceremonia Cívica',
      'place': 'Pachuca de Soto',
      'start': '2024-09-23',
      'color': 'var(--wine)',
        'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> Ceremonia cívica de Arriamiento de nuestra Bandera Nacional. <a href="https://twitter.com/Contraloria_Hgo/status/1838304654972850647?ref_src=twsrc%5Etfw">Septiembre 23, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 5,
    'title': 'Reforestación de la zona de preservaciónecologica.',
    'place': 'Pachuca de Soto',
    'start': '2024-09-23',
    'color': 'var(--wine)',
      'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> Reforestación de la zona de preservaciónecologica cerro del lobo. <a href="https://twitter.com/Contraloria_Hgo/status/1838305684959482033?ref_src=twsrc%5Etfw">Septiembre 23, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
    {
    'id': 6,
    'title': 'La 3ª Convención Regional Centro .',
    'place': 'Pachuca de Soto',
    'start': '2024-09-26',
    'color': 'var(--wine)',
      'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> Nuestro titular Alvaro Bardales, en representación del Gobernador Julio Menchaca, asistió a la 3era Convención Regional de la Región Centro del IMCP.<a href="https://twitter.com/Contraloria_Hgo/status/1839757381170827264?ref_src=twsrc%5Etfw">Septiembre 26, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 7,
    'title': 'Llevamos a cabo una reunión de gabinete.',
    'place': 'Pachuca de Soto',
    'start': '2024-09-27',
    'color': 'var(--wine)',
      'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> ¡Nuestro titular Alvaro Bardales estuvo presente en la reunión de gabinete, presidida por el Gobernador Julio Menchaca!.<a href="https://twitter.com/Contraloria_Hgo/status/1839771769126711545?ref_src=twsrc%5Etfw">Septiembre 27, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
  },
  {
    'id': 8,
    'title': 'Feria de San Francisco 2024.',
    'place': 'Pachuca de Soto',
    'start': '2024-09-27',
    'color': 'var(--wine)',
      'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> Seguimos comprometidos con el trabajo en equipo para impulsar acciones en beneficio del pueblo hidalguense.<a href="https://twitter.com/Contraloria_Hgo/status/1839850906885431687?ref_src=twsrc%5Etfw">Septiembre 27, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 9,
  'title': 'Entrega Recepción de Obra Pública.',
  'place': 'Pachuca de Soto',
  'start': '2024-10-02',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> Nuestro titular Alvaro Bardales, junto a su equipo de trabajo sostuvo una reunión vía remota con las administraciones municipales para abordar el tema sobre: "Entrega Recepción de Obra Pública.”<a href="https://twitter.com/Contraloria_Hgo/status/1841611383864963377?ref_src=twsrc%5Etfw">Octubre 02, 2024</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 10,
  'title': 'Certificado del Sistema Antisoborno.',
  'place': 'Pachuca de Soto',
  'start': '2025-01-30',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> Certificado del Sistema Antisoborno ISO 37001:2016, como reconocimiento al compromiso.<a href="https://twitter.com/Contraloria_Hgo/status/1885055513475371120?ref_src=twsrc%5Etfw">Enero  30, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 11,
  'title': ' Primera Reunión Plenaria 2025.',
  'place': 'Pachuca de Soto',
  'start': '2025-01-29',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr"> Primera Reunión Plenaria 2025, La Secretaría de Anticorrupción y Buen Gobierno.<a href="https://twitter.com/ContraloresMX/status/1884726659976487358?ref_src=twsrc%5Etfw">Enero 29, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 12,
  'title': ' Segundo bloque de la Reunión de Trabajo.',
  'place': 'Pachuca de Soto',
  'start': '2025-02-05',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Segundo bloque de la Reunión de Trabajo entre autoridades federales, estatales y municipales en temas migratorios.<a href="https://twitter.com/Contraloria_Hgo/status/1887581147174937034?ref_src=twsrc%5Etfw">Febrero 05, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 13,
  'title': 'Reunión de Gabinete.',
  'place': 'Pachuca de Soto',
  'start': '2025-02-06',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete.<a href="https://x.com/juliomenchaca_/status/1887655782075773330?ref_src=twsrc%5Etfw">Febrero 06, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 14,
  'title': 'Verificación del pavimento asfáltico.',
  'place': 'Pachuca de Soto',
  'start': '2025-02-07',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Verificación del pavimento asfáltico en la calle “CECyTEH”, además de la donación de material de protección civil.<a href="https://twitter.com/CECyTEHChilcuau/status/1887931822505386126?ref_src=twsrc%5Etfw">Febrero 07, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 15,
  'title': 'Entrega de equipos de Contraloría Social.',
  'place': 'Pachuca de Soto',
  'start': '2025-02-08',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Entrega de equipos de Contraloría Social<a href="https://twitter.com/CECyTEHChilcuau/status/1887931822505386126?ref_src=twsrc%5Etfw">Febrero 08, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 16,
  'title': 'Reunión de Gabinete.',
  'place': 'Pachuca de Soto',
  'start': '2025-05-05',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/juliomenchaca_/status/1919488932896465070?ref_src=twsrc%5Etfw">mayo 08, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 17,
  'title': 'Capacitación declaración patrimonial.',
  'place': 'Pachuca de Soto',
  'start': '2025-05-05',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/Contraloria_Hgo/status/1919527755458478220?ref_src=twsrc%5Etfw">mayo 08, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 18,
  'title': 'Capacitación declaración patrimonial.',
  'place': 'Pachuca de Soto',
  'start': '2025-04-30',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/Contraloria_Hgo/status/1917717890872271293?ref_src=twsrc%5Etfw">abril 30, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 19,
  'title': 'Capacitación declaración patrimonial.',
  'place': 'Pachuca de Soto',
  'start': '2025-05-08',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/Contraloria_Hgo/status/1920648189989867710?ref_src=twsrc%5Etfw">mayo 08, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 20,
  'title': 'Día de la integridad.',
  'place': 'Pachuca de Soto',
  'start': '2025-05-09',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/Contraloria_Hgo/status/1920904382352121955?ref_src=twsrc%5Etfw">mayo 08, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 21,
  'title': 'Inauguración del Parque Cultural Hidalguense.',
  'place': 'Pachuca de Soto',
  'start': '2025-05-11',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/juliomenchaca_/status/1921715967018647771?ref_src=twsrc%5Etfw">mayo 11, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 22,
  'title': 'Supervisión de obra.',
  'place': 'Pachuca de Soto',
  'start': '2025-05-11',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/juliomenchaca_/status/1921961382464917511?ref_src=twsrc%5Etfw">mayo 11, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 23,
  'title': 'Supervisión de obra.',
  'place': 'Pachuca de Soto',
  'start': '2025-05-12',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/juliomenchaca_/status/1921961382464917511?ref_src=twsrc%5Etfw">mayo 12, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 24,
  'title': 'Rutas de la Transformación.',
  'place': 'Huehuetla',
  'start': '2025-05-13',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/juliomenchaca_/status/1922401874508148865?ref_src=twsrc%5Etfw">mayo 13, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 25,
  'title': 'Programa de Inversión.',
  'place': 'Tenango de Doria ',
  'start': '2025-05-14',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/juliomenchaca_/status/1922785116847329611?ref_src=twsrc%5Etfw">mayo 14, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 26,
  'title': 'Inauguración del Centro Cultural Regional de la Sierra Otomí Tepehua.',
  'place': 'SIERRA OTOMÍ TEPEHUA',
  'start': '2025-05-14',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/juliomenchaca_/status/1922700794253443413?ref_src=twsrc%5Etfw">mayo 14, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 27,
  'title': 'Instalación del Consejo del Sistema Nacional de Acceso a la Información Pública.',
  'place': 'Pachuca de Soto',
  'start': '2025-05-16',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/juliomenchaca_/status/1923582898365510020?ref_src=twsrc%5Etfw">mayo 16, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 28,
  'title': 'Reunión de Gabinete.',
  'place': 'Pachuca de Soto',
  'start': '2025-06-05',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete<a href="https://twitter.com/juliomenchaca_/status/1930731934189310456?ref_src=twsrc%5Etfw">junio 05, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 29,
  'title': 'Cierre de campaña declaración patrimonial.',
  'place': 'Pachuca de Soto',
  'start': '2025-06-09',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Cierre de campaña declaración patrimonial<a href="https://twitter.com/MarycarmenMandC/status/1932275863732531701?ref_src=twsrc%5Etfw">junio 09, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 30,
  'title': 'Entrega de pavimentación Metztitlán.',
  'place': 'Metztitlán, Hidalgo',
  'start': '2025-06-11',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Entrega de pavimentación Metztitlán<a href="https://twitter.com/Contraloria_Hgo/status/1932938078613553214?ref_src=twsrc%5Etfw">junio 11, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 31,
  'title': 'Programa “Cartas con Valor” Atlapexco.',
  'place': 'Atlapexco, Hidalgo',
  'start': '2025-06-12',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Programa “Cartas con Valor” Atlapexco<a href="https://twitter.com/Contraloria_Hgo/status/1933198648957186339?ref_src=twsrc%5Etfw">junio 12, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 32,
  'title': 'Programa “Cartas con Valor” Calnali.',
  'place': 'Calnali, Hidalgo',
  'start': '2025-06-12',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Programa “Cartas con Valor” Calnali<a href="https://twitter.com/Contraloria_Hgo/status/1933199211362697721?ref_src=twsrc%5Etfw">junio 12, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 33,
  'title': 'Supervisión en Huazalingo del puente vehicular.',
  'place': 'Huazalingo, Hidalgo',
  'start': '2025-06-13',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Programa “Supervisión en #Huazalingo del puente vehicular <a href="https://twitter.com/Contraloria_Hgo/status/1934751028777246956?ref_src=twsrc%5Etfw">junio 13, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 34,
  'title': 'Jornadas por la Paz.',
  'place': 'Huejutla de Reyes, Hidalgo',
  'start': '2025-06-13',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Programa “Jornadas por la Paz<a href="https://twitter.com/Contraloria_Hgo/status/1934750377506701661?ref_src=twsrc%5Etfw">junio 13, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 35,
  'title': 'Villa de Tezontepec.',
  'place': 'Villa de Tezontepec',
  'start': '2025-06-20',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Programa “Jornadas por la Paz<a href="https://twitter.com/CriterioHidalgo/status/1937669570849862056?ref_src=twsrc%5Etfw">junio 20, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 36,
  'title': 'Asamblea Nacional de la Comisión Permanente de Contralores Estados–Federación.',
  'place': 'Aguascalientes, Aguascalientes',
  'start': '2025-07-03',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Comisión Permanente de Contralores Estados–Federación<a href="https://twitter.com/Contraloria_Hgo/status/1940926279458361358?ref_src=twsrc%5Etfw">julio 03, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 37,
  'title': 'Lunes Cívico.',
  'place': 'Pachuca de Soto, Hidalgo',
  'start': '2025-07-07',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Lunes Cívico<a href="https://twitter.com/Contraloria_Hgo/status/1942272609481114079?ref_src=twsrc%5Etfw">julio 07, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 38,
  'title': 'Reunión de Gabinete 07 de julio.',
  'place': 'Pachuca de Soto, Hidalgo',
  'start': '2025-07-07',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete 07 de julio<a href="https://twitter.com/Contraloria_Hgo/status/1942383901927784451?ref_src=twsrc%5Etfw">julio 07, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 39,
  'title': 'Supervisión de obra.',
  'place': 'Pachuca de Soto, Hidalgo',
  'start': '2025-07-10',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Supervisión de obra<a href="https://twitter.com/Contraloria_Hgo/status/1943719595883348020?ref_src=twsrc%5Etfw">julio 10, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 40,
  'title': 'Rutas de la transformación.',
  'place': 'Hidalgo',
  'start': '2025-07-10',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Rutas de la transformación<a href="https://twitter.com/Contraloria_Hgo/status/1943463305135440100?ref_src=twsrc%5Etfw">julio 10, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 41,
  'title': 'Entrega de certificación por parte de la EMA.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-07-15',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Entrega de certificación por parte de la EMA<a href="https://twitter.com/Contraloria_Hgo/status/1945258512071766045?ref_src=twsrc%5Etfw">julio 15, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},





{
  'id': 42,
  'title': 'Inauguración del nuevo edificio de la Contraloría.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-07-15',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Inauguración del nuevo edificio de la Contraloría<a href="https://twitter.com/Contraloria_Hgo/status/1943463305135440100?ref_src=twsrc%5Etfw">julio 15, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 43,
  'title': '1.ª Sesión del COPLADEH 2025.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-07-23',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">1.ª Sesión del COPLADEH 2025<a href="https://twitter.com/Contraloria_Hgo/status/1948198952182104068?ref_src=twsrc%5Etfw">julio 23, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 44,
  'title': 'Entrega de los nuevos andadores turísticos.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-07-30',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Entrega de los nuevos andadores turísticos.<a href="https://twitter.com/Contraloria_Hgo/status/1950693417383829877?ref_src=twsrc%5Etfw">julio 30, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 45,
  'title': 'Inauguración de la nueva Casa del Artesano.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-07-30',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Inauguración de la nueva Casa del Artesano.<a href="https://twitter.com/Contraloria_Hgo/status/1950693277960974454?ref_src=twsrc%5Etfw">julio 30, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 46,
  'title': 'Rutas de la transformación.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-07-30',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Rutas de la transformación.<a href="https://twitter.com/Contraloria_Hgo/status/1950693730442162371?ref_src=twsrc%5Etfw">julio 30, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 47,
  'title': 'Entrega de reconocimientos.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-08-05',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Entrega de reconocimientos.<a href="https://twitter.com/Contraloria_Hgo/status/1953142432209436987?ref_src=twsrc%5Etfw">agosto 05, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 48,
  'title': 'Reunión de Gabinete.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-08-05',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete.<a href="https://twitter.com/Contraloria_Hgo/status/1952897215422456303?ref_src=twsrc%5Etfw">agosto 05, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 48,
  'title': 'Conmemoración de los pueblos indígenas.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-08-07',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Conmemoración de los pueblos indígenas.<a href="https://twitter.com/Contraloria_Hgo/status/1953650144827605015?ref_src=twsrc%5Etfw">agosto 07, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 49,
  'title': 'Mesa de trabajo.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-08-08',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Mesa de trabajo sobre el Sistema de Gestión Ambiental.<a href="https://twitter.com/Bienestar_Hgo/status/1955032598352171479?ref_src=twsrc%5Etfw">agosto 08, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 50,
  'title': 'Entrega de Resultados y Anuncio de Acciones de la CAASIM.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-08-13',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Entrega de Resultados y Anuncio de Acciones de la CAASIM.<a href="https://twitter.com/Bienestar_Hgo/status/1955737545939046559?ref_src=twsrc%5Etfw">agosto 13, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 51,
  'title': 'Encuentros Nacionales por la Armonización Legislativa .',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-08-20',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Encuentros Nacionales por la Armonización Legislativa .<a href="https://twitter.com/Contraloria_Hgo/status/1958373104599601267?ref_src=twsrc%5Etfw">agosto 20, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 52,
  'title': 'Reunión de trabajo con el Auditor Superior de la Federación.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-08-29',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de trabajo con el Auditor Superior de la Federación.<a href="https://twitter.com/ASF_Mexico/status/1961551654395981989?ref_src=twsrc%5Etfw">agosto 29, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 53,
  'title': '5 de septiembre Informe de Gobierno.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-09-05',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">5 de septiembre Informe de Gobierno.<a href="https://twitter.com/juliomenchaca_/status/1964039284626801138?ref_src=twsrc%5Etfw">Septiembre 05, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 54,
  'title': 'Informe 12 de septiembre Huazalingo.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-09-12',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Informe 12 de septiembre Huazalingo.<a href="https://twitter.com/Contraloria_Hgo/status/1967673738922692991?ref_src=twsrc%5Etfw">Septiembre 12, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 55,
  'title': 'Informe San Felipe.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-09-12',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Informe San Felipe.<a href="https://twitter.com/Contraloria_Hgo/status/1967673146720522741?ref_src=twsrc%5Etfw">Septiembre 12, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 56,
  'title': 'Informe Huautla.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-09-13',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Informe Huautla.<a href="https://twitter.com/Contraloria_Hgo/status/1967674122965749979?ref_src=twsrc%5Etfw">Septiembre 13, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 57,
  'title': 'Informe Yahualica.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-09-14',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Informe Yahualica.<a href="https://twitter.com/Contraloria_Hgo/status/1967674318848200963?ref_src=twsrc%5Etfw">Septiembre 14, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 58,
  'title': 'Inauguración Complejo Hidalgo Honesto.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-09-29',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Inauguración Complejo Hidalgo Honesto.<a href="https://twitter.com/juliomenchaca_/status/1972788103032316308?ref_src=twsrc%5Etfw">Septiembre 29, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 58,
  'title': 'Reunión contralores México.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-10-02',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión contralores México.<a href="https://twitter.com/Contraloria_Hgo/status/1974279604484690321?ref_src=twsrc%5Etfw">Octubre 02, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 59,
  'title': 'Reunión de gabinete de emergencia Huracán Priscila.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-10-11',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de gabinete de emergencia Huracán Priscila.<a href="https://twitter.com/juliomenchaca_/status/1977194988036669600?ref_src=twsrc%5Etfw">Octubre 11, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 60,
  'title': 'Localidad de Chichiltepec.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-10-19',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Localidad de Chichiltepec .<a href="https://twitter.com/Contraloria_Hgo/status/1980407518888391075?ref_src=twsrc%5Etfw">Octubre 19, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 61,
  'title': 'Localidad de Tianguis.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-10-19',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Localidad de Tianguis.<a href="https://twitter.com/Contraloria_Hgo/status/1980407335286894609?ref_src=twsrc%5Etfw">Octubre 19, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 62,
  'title': 'Recorrido por comunidades.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-10-19',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Recorrido por comunidades.<a href="https://twitter.com/Contraloria_Hgo/status/1980407122446930284?ref_src=twsrc%5Etfw">Octubre 19, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 63,
  'title': 'El secretario de Contraloría, Álvaro Bardales Ramírez.',
  'place': 'Secretaría de Contraloría, Hidalgo',
  'start': '2025-11-11',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">La importancia de la Contraloría en la fiscalización de los recursos público.<a href="https://twitter.com/Contraloria_Hgo/status/1988991716838527173?s=20?ref_src=twsrc%5Etfw">Noviembre 11, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 64,
  'title': 'Apoyos e insumos agropecuarios en Hueyapa Tlanchinol.',
  'place': 'Hueyapa Tlanchinol.',
  'start': '2025-11-12',
  'color': 'var(--wine)',

'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Apoyos e insumos agropecuarios en Hueyapa Tlanchinol.<a href="https://twitter.com/juliomenchaca_/status/1988761898334982527?s=20?ref_src=twsrc%5Etfw">Noviembre 12, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
  'id': 65,
  'title': 'Séptima Edición del Tianguis Nacional de Pueblos Mágicos 2025.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-11-14',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Séptima Edición del Tianguis Nacional de Pueblos Mágicos 2025.<a href="https://twitter.com/gobiernohidalgo/status/1989438303062639073?s=20?ref_src=twsrc%5Etfw">Noviembre 14, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 66,
  'title': 'Ceremonia De Inicio De La Revolución.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-11-20',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Ceremonia De Inicio De La Revolución.<a href="https://twitter.com/gobiernohidalgo/status/1991628358350979548?s=20?ref_src=twsrc%5Etfw">Noviembre 20, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 67,
  'title': 'Sesión extraordinaria de CPCE-M.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-11-20',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Sesión extraordinaria de CPCE-M.<a href="https://twitter.com/gobiernohidalgo/status/1991997300466708600?s=20?ref_src=twsrc%5Etfw">Noviembre 20, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 68,
  'title': 'Visita Universidad Tecnológica.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-11-27',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Visita Universidad Tecnológica<a href="https://twitter.com/Contraloria_Hgo/status/1994435905717760497?s=20?ref_src=twsrc%5Etfw">Noviembre 27, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},




{
  'id': 69,
  'title': 'Comparecencia.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-11-24',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Comparecencia<a href="https://twitter.com/juliomenchaca_/status/1993482028419793043?s=20?ref_src=twsrc%5Etfw">Noviembre 24, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 71,
  'title': 'Feria de la Participación Ciudadana.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-12-02',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Feria de la Participación Ciudadana<a href="https://twitter.com/Contraloria_Hgo/status/1995992862761078810?s=20?ref_src=twsrc%5Etfw">Diciembre 02, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 72,
  'title': 'Comité de Obra de Mineral del Monte y de seis Comités de Contraloría Social.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-12-03',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Comité de Obra de Mineral del Monte y de seis Comités de Contraloría Social <a href="https://twitter.com/Contraloria_Hgo/status/1996716248709656840?s=20?ref_src=twsrc%5Etfw">Diciembre 03, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 73,
  'title': 'Reunión de Gabinete 2025.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-12-05',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión de Gabinete 2025<a href="http://twitter.com/juliomenchaca_/status/1997094307124154618?s=20?s=20?ref_src=twsrc%5Etfw">Diciembre 05, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 74,
  'title': 'Presentación la nueva Oficina Virtual de Revisión de Bases.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-12-11',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Presentación la nueva Oficina Virtual de Revisión de Bases<a href="http://twitter.com/Contraloria_Hgo/status/1999250107766800714?s=20?ref_src=twsrc%5Etfw">Diciembre 11, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 75,
  'title': 'Muévete Contra La Corrupción.',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-12-10',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Muévete Contra La Corrupción<a href="http://twitter.com/Contraloria_Hgo/status/1998891593563328549?s=20?ref_src=twsrc%5Etfw">Diciembre 10, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 76,
  'title': '17 de diciembre de 2025 Sesión Ordinaria de la Secretaría Técnica ',
  'place': 'Pachuca Hidalgo.',
  'start': '2025-12-17',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Muévete Contra La Corrupción<a href="http://twitter.com/Contraloria_Hgo/status/2001455719766221194?s=20?ref_src=twsrc%5Etfw">Diciembre 17, 2025</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 77,
  'title': 'Reunión medios de comunicación ',
  'place': 'Huasteca de Hidalgo.',
  'start': '2026-01-06',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión medios de comunicación <a href="http://twitter.com/Contraloria_Hgo/status/2008691834168701086?s=20?ref_src=twsrc%5Etfw">Enero 06, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 78,
  'title': 'Reunión Gabinete',
  'place': 'Pachuca de Soto, Hidalgo.',
  'start': '2026-01-12',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión medios de comunicación <a href="http://twitter.com/juliomenchaca_/status/2010830694818124068?s=20?ref_src=twsrc%5Etfw">Enero 12, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 79,
  'title': 'Entrega de cascos',
  'place': 'Pachuca de Soto, Hidalgo.',
  'start': '2026-01-22',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Entrega de cascos <a href="http://twitter.com/Contraloria_Hgo/status/2014469887750484442?s=20?ref_src=twsrc%5Etfw">Enero 22, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 80,
  'title': 'Asamblea Plenaria',
  'place': 'Pachuca de Soto, Hidalgo.',
  'start': '2026-01-22',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Asamblea Plenaria <a href="http://twitter.com/Contraloria_Hgo/status/2014488253416755362?s=20?ref_src=twsrc%5Etfw">Enero 22, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 81,
  'title': 'Reunión Gabinete',
  'place': 'Pachuca de Soto, Hidalgo.',
  'start': '2026-02-04',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Reunión Gabinete <a href="http://twitter.com/Contraloria_Hgo/status/2019184762683027503?s=20?ref_src=twsrc%5Etfw">Enero 22, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 82,
  'title': 'Homenaje a la Bandera',
  'place': 'Pachuca Hidalgo.',
  'start': '2026-02-20',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Homenaje a la Bandera<a href="http://twitter.com/Contraloria_Hgo/status/2025024508277473541?s=20?ref_src=twsrc%5Etfw">Febrero 20, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 83,
  'title': 'Rutas de la Transformación',
  'place': 'Hidalgo.',
  'start': '2026-02-17',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Rutas de la Transformación <a href="http://twitter.com/Contraloria_Hgo/status/2023875888316662262?s=20?ref_src=twsrc%5Etfw">Febrero 17, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 83,
  'title': 'Rutas de la Transformación',
  'place': 'Hidalgo.',
  'start': '2026-02-17',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Rutas de la Transformación <a href="http://twitter.com/Contraloria_Hgo/status/2023875888316662262?s=20?ref_src=twsrc%5Etfw">Febrero 17, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 84,
  'title': 'Conferencia de prensa',
  'place': 'Hidalgo.',
  'start': '2026-02-23',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Conferencia de prensa<a href="http://twitter.com/Contraloria_Hgo/status/2026076394019561776?s=20?ref_src=twsrc%5Etfw">Febrero 23, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 85,
  'title': 'Rutas de la transformación',
  'place': 'Mineral de la Reforma.',
  'start': '2026-02-23',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Rutas de la transformación<a href="http://twitter.com/juliomenchaca_/status/2026073938330108184?ref_src=twsrc%5Etfw">Febrero 23, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
  'id': 86,
  'title': 'Homenaje a la bandera.',
  'place': 'Pachuca de Soto.',
  'start': '2026-02-24',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Homenaje a la bandera<a href="http://twitter.com/juliomenchaca_/status/2026371585108529380?s=20?ref_src=twsrc%5Etfw">Febrero 24, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
  'id': 87,
  'title': 'Inauguración de la semana del periodismo.',
  'place': 'Pachuca de Soto.',
  'start': '2026-02-24',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Inauguración de la semana del periodismo.<a href="http://twitter.com/gobiernohidalgo/status/2026502339595571651?s=20?ref_src=twsrc%5Etfw">Febrero 24, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},




{
  'id': 88,
  'title': 'Rutas de la transformación.',
  'place': 'Pachuca de Soto.',
  'start': '2026-02-26',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es" dir="ltr">Rutas de la transformación..<a href="http://twitter.com/gobiernohidalgo/status/2027149174764920995?s=20?ref_src=twsrc%5Etfw">Febrero 26, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 89,
  'title': 'Encuentro con Cebaderos del Altiplano.',
  'place': 'Hidalgo.',
  'start': '2026-02-28',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Encuentro con Cebaderos del Altiplano<a href="http://twitter.com/Contraloria_Hgo/status/2028501057068826659?s=20?ref_src=twsrc%5Etfw">Febrero 28, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},



{
  'id': 90,
  'title': 'Casa de Día Almoloya.',
  'place': 'Hidalgo.',
  'start': '2026-03-12',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Casa de Día Almoloya<a href="http://twitter.com/juliomenchaca_/status/2032201254018171328?s=20?ref_src=twsrc%5Etfw">Marzo 12, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
 'id': 91,
  'title': 'Sesión Ordinaria del COCODI 2026',
  'place': 'Hidalgo.',
  'start': '2026-03-18',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Sesión Ordinaria del COCODI 2026<a href="http://twitter.com/Contraloria_Hgo/status/2034387258611028357?s=20?ref_src=twsrc%5Etfw">Marzo 18, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
 'id': 92,
  'title': 'Transparencia y la rendición de cuentas.',
  'place': 'Hidalgo.',
  'start': '2026-03-19',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Transparencia y la rendición decuentas.<a href="http://twitter.com/Contraloria_Hgo/status/2034738909846851789?s=20?ref_src=twsrc%5Etfw">Marzo 19, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},
{
 'id': 93,
  'title': 'Plaza del Centro Histórico en el municipio de Tecozautla.',
  'place': 'Tecozautla, Hidalgo.',
  'start': '2026-03-20',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Plaza del Centro Histórico en el municipio de Tecozautla.<a href="http://twitter.com/Contraloria_Hgo/status/2035172460618723572?s=20?ref_src=twsrc%5Etfw">Marzo 20, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
 'id': 94,
  'title': 'Construcción del nuevo pórtico del acceso principal de la UPMH.',
  'place': 'Hidalgo.',
  'start': '2026-03-24',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Construcción del nuevo pórtico del acceso principal de la UPMH<a href="http://twitter.com/Contraloria_Hgo/status/2036620531722760592?s=20?ref_src=twsrc%5Etfw">Marzo 24, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
 'id': 95,
  'title': 'Capacitación en Materia de Control Interno.',
  'place': 'Hidalgo.',
  'start': '2026-03-25',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Capacitación en Materia de Control Interno<a href="http://twitter.com/Contraloria_Hgo/status/2036930562846580951?s=20?ref_src=twsrc%5Etfw">Marzo 25, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},


{
 'id': 96,
  'title': 'Comité Interinstitucional de Transición al Nuevo Modelo de Transparencia en el Estado de Hidalgo.',
  'place': 'Hidalgo.',
  'start': '2026-03-25',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Comité Interinstitucional de Transición al Nuevo Modelo de Transparencia en el Estado de Hidalgo.<a href="http://twitter.com/Contraloria_Hgo/status/2036962820714045625?s=20?ref_src=twsrc%5Etfw">Marzo 25, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
 'id': 97,
  'title': 'Nuevo Modelo de Transparencia en el Estado de Hidalgo.',
  'place': 'Hidalgo.',
  'start': '2026-04-07',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Nuevo Modelo de Transparencia en el Estado de Hidalgo.<a href="http://twitter.com/Contraloria_Hgo/status/2041632161304871068?s=20?ref_src=twsrc%5Etfw">Abril 07, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},

{
 'id': 98,
  'title': 'Reunión Mensual de Gabinete.',
  'place': 'Hidalgo.',
  'start': '2026-04-06',
  'color': 'var(--wine)',
    'description': '<blockquote class="twitter-tweet"><p lang="es"  dir="ltr">Reunión Mensual de Gabinete.<a href="http://twitter.com/Contraloria_Hgo/status/2041259902849712464?s=20?ref_src=twsrc%5Etfw">Abril 06, 2026</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
},





];



